import { dataChevronDoubleUp } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronDoubleUp = /*#__PURE__*/createIcon(dataChevronDoubleUp)
export default IconChevronDoubleUp
